// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__2zf3a","content":"style_content__2k_Qy","text":"style_text__3kqVP","selectContent":"style_selectContent__1AbXx","select":"style_select__1V7dG"};